import { useTranslation } from "react-i18next";

const useSystemAdvantagesData = () => {
  const { t } = useTranslation("advantages");

  const data = [
    {
      img: {
        src: "/images/advantages/advantages-card-1.png",
        alt: t("one.alt")
      },
      description: t("one.description")
    },
    {
      img: {
        src: "/images/advantages/advantages-card-2.png",
        alt: t("two.alt")
      },
      description: t("two.description")
    },
    {
      img: {
        src: "/images/advantages/advantages-card-3.png",
        alt: t("three.alt")
      },
      description: t("three.description")
    },
    {
      img: {
        src: "/images/advantages/advantages-card-4.png",
        alt: t("four.alt")
      },
      description: t("four.description")
    },
    {
      img: {
        src: "/images/advantages/advantages-card-5.png",
        alt: t("five.alt")
      },
      description: t("five.description")
    },
    {
      img: {
        src: "/images/advantages/advantages-card-6.png",
        alt: t("six.alt")
      },
      description: t("six.description")
    }
  ];

  return data;
};

export default useSystemAdvantagesData;
